// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1BJbD","footer":"ModalInfo_footer__1j1dG"};